<template>
  <div v-if="isVisible" class="modal" @click.self="closeModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <slot></slot>
        <button class="close" @click="closeModal">&times;</button>
      </div>
    </div>
    <div class="modal-backdrop show" />
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit('update:isVisible', false);
    },
  },
}
</script>

<style scoped></style>
